import { CardContent, type SxProps } from '@mui/material'
import { SafeImage } from 'shared/ui/atoms/safeImage'
import { BaseEventCard, type EventDTO } from '~entities/index'

import { useImageLoader } from '~sharedLib'
import { Typography } from '~sharedUI'

export const VerticalCard = ({
	info,
	isMain = false,
	isSmall = false,
	sx
}: {
	info: EventDTO | undefined
	isMain?: boolean
	isSmall?: boolean
	sx?: SxProps
}) => {
	const isLoaded = useImageLoader(info?.picture)

	return (
		<BaseEventCard
			info={info}
			sx={{
				...{
					display: 'flex',
					flex: 1,
					flexDirection: 'column',
					height: isMain ? undefined : isSmall ? '384px' : '530px'
				},
				...sx
			}}
		>
			<SafeImage
				src={info?.picture}
				sx={{
					height: isSmall ? '54%' : '60%'
				}}
			/>

			<CardContent
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					padding: '16px 24px 24px'
				}}
			>
				<Typography
					{...(isLoaded && {
						sx: {
							display: '-webkit-box',
							WebkitLineClamp: isSmall ? 3 : 4,
							WebkitBoxOrient: 'vertical',
							overflow: 'hidden'
						}
					})}
					fontWeight='bold'
					lineHeight={isMain ? '52px' : '32px'}
					fontSize={isMain ? 'xl' : 'sm'}
				>
					{info?.name}
				</Typography>
				<Typography
					fontSize={isMain ? 'lg' : 'xs'}
					lineHeight={isMain ? '40px' : '24px'}
					fontWeight='bold'
					color='text.accent'
				>
					{info?.date}
				</Typography>
			</CardContent>
		</BaseEventCard>
	)
}
